var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2197_10214)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#29C483"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5413 16.1791C23.4552 15.3783 23.0927 14.7548 22.4536 14.3085C21.8207 13.8623 20.9972 13.6392 19.9833 13.6392C19.2705 13.6392 18.6591 13.7461 18.1491 13.9601C17.639 14.174 17.2488 14.4644 16.9784 14.8312C16.7081 15.198 16.5698 15.6167 16.5637 16.0874C16.5637 16.4786 16.6528 16.8179 16.831 17.1052C17.0153 17.3925 17.2642 17.637 17.5776 17.8387C17.891 18.0343 18.2382 18.1994 18.6191 18.3339C19.0001 18.4683 19.3842 18.5814 19.7713 18.6731L21.5411 19.1133C22.2539 19.2783 22.939 19.5014 23.5966 19.7826C24.2602 20.0638 24.8532 20.4184 25.3755 20.8463C25.904 21.2742 26.3218 21.7907 26.6291 22.3959C26.9363 23.001 27.09 23.7101 27.09 24.5231C27.09 25.6235 26.8073 26.5924 26.242 27.4298C25.6766 28.2612 24.8593 28.9122 23.7901 29.3829C22.727 29.8475 21.4397 30.0797 19.928 30.0797C18.4594 30.0797 17.1843 29.8536 16.1028 29.4012C15.0274 28.9489 14.1856 28.2887 13.5772 27.4206C12.975 26.5526 12.6493 25.4951 12.6002 24.2481H15.9645C16.0137 24.9021 16.2165 25.4462 16.5729 25.8802C16.9293 26.3142 17.3932 26.6382 17.9647 26.8521C18.5423 27.0661 19.1876 27.1731 19.9004 27.1731C20.6439 27.1731 21.2953 27.063 21.8545 26.843C22.4198 26.6168 22.8622 26.305 23.1818 25.9077C23.5013 25.5043 23.6642 25.0336 23.6703 24.4956C23.6642 24.0066 23.5197 23.6032 23.2371 23.2853C22.9544 22.9613 22.5581 22.6923 22.048 22.4784C21.5441 22.2583 20.9542 22.0627 20.2783 21.8916L18.1306 21.3414C16.5759 20.9441 15.347 20.3419 14.4436 19.535C13.5465 18.722 13.0979 17.6431 13.0979 16.2983C13.0979 15.1918 13.399 14.223 14.0012 13.3916C14.6096 12.5603 15.4361 11.9153 16.4807 11.4569C17.5253 10.9923 18.7082 10.76 20.0294 10.76C21.369 10.76 22.5427 10.9923 23.5505 11.4569C24.5644 11.9153 25.3602 12.5541 25.9378 13.3733C26.5154 14.1863 26.8134 15.1215 26.8319 16.1791H23.5413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1199,
    y: 8,
    width: 3.44995,
    height: 3.44995,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.1199,
    y: 28.6997,
    width: 3.44995,
    height: 3.44995,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2197_10214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceLogo);
export default __webpack_public_path__ + "static/media/balance-logo.23d8d69426d92ea48385ae8967b91284.svg";
export { ForwardRef as ReactComponent };